<div class="form-row m-0 cursor-pointer">
  <mat-form-field appearance="outline" class="upload w-100 {{ isInputFilled ? 'input-filled' : '' }}">
    <input matInput [value]="inputLabel" #searchTextField type="text" disabled />
    <button mat-button matSuffix mat-icon-button class="ml-2">
      <i *ngIf="isInputFilled" class="fas fa-times blue" (click)="resetFile()"></i>
      <i *ngIf="!isInputFilled" class="fas fa-paperclip blue" (click)="clickInput()"></i>
    </button>
  </mat-form-field>
</div>